import React, { useRef, useEffect, useState } from 'react';
import { FormattedNumber, FormattedDate } from 'react-intl';
import ReactToPrint from 'react-to-print';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import PaymentContainer from 'components/PaymentContainer/PaymentContainer';
import styles from './PaymentPlanConfirmPageData.module.scss';
import PageLink from 'components/PageLink/PageLink';
import StepIndicator from 'components/StepIndicator/StepIndicator';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const PaymentPlanConfirmPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const componentRef = useRef(null);
  const [eventTracked, setEventTracked] = useState<boolean>(false);

  useEffect(() => {
    if (eventTracked == false) {
      var tagManagerArgs: any;
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Payment Plan Creation',
          checkout_step_number: '3',
          is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
        }
      }
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);
    
  return (
    <div className={styles.wrapper_main}>
      {!Model.HasProposedPlan && (
        <section className="CreateRepaymentPlan__section">
          <StepIndicator
            ActiveStep={Model?.ActiveWizardStep?.ActiveStep}
            TotalSteps={3}
            StepText={PageData?.StepText}
            OfText={PageData?.OfText}
          />
        </section>
      )}
      <div className={styles.wrapper}>
              <div className="sectionGutterV Section--secondaryBg u-paddingTz">
                <div className={styles.container}>
                  <main className="CreateRepaymentPlan u-paddingTz">
              <section className="CreateRepaymentPlan__section">
                {!Model.HasProposedPlan ? (
                  <h1 className="CreateRepaymentPlan__heading u-marginTz">
                    {PageData?.PaymentPlanHeader}
                  </h1>
                ) : (
                  <h1 className="CreateRepaymentPlan__heading u-marginTz">
                    {PageData?.ProposedPaymentPlanHeader}
                  </h1>
                )}
              </section>
              <RepaymentList
                Heading={PageData?.YourRapaymentHeader}
                BalanceLabel={PageData?.PaymentPlanItemDebtBalanceLabel}
                BalanceAmount={Model?.FormattedCurrencyDebtBalance}
                DiscountBalancelabel={PageData?.PaymentPlanItemDiscountAmountLabel}
                DiscountBalanceAmount={Model?.FormattedCurrencyOfferDiscountAmount}
                Monthlylabel={PageData?.PaymentPlanItemNumberOfRegularPaymentsLabel}
                NumberofMonth={Model.NumberOfRegularPayments}
                Mothlyamount={Model?.FormattedCurrencyRegularPayment}
                Currencysymbol={Model?.FormattedCurrencySymbol}
                Finallabel={PageData?.PaymentPlanItemLastPaymentValueLabel}
                FinalAmount={Model?.FormattedCurrencyLastPayment}
                Totaltext={PageData?.TotalPlanLabel}                
                Totalamount = {Model.FormattedCurrencyTotalPaymentAmount}
                DisposableIncomeLimit={Model?.DisposableIncomeLimit}
                DiscountedDebtBalanceRaw={Model?.DiscountAmount}
                UpdatePlanConfirm={true}
                PlanDueDateInfoText={PageData?.PaymentInfoDateMessage}
                PlanDueDate={Model?.FormattedShortDateFirstPayment}
              />
              <section className="CreateRepaymentPlan__section">
                <div className="Grid Grid--gutterH Grid--white GridWhite--smFull u-paddingLxsm u-paddingRxsm">
                  <div className="Gride-cell">
                    <p className="CreateRepaymentPlan__plainText Payment_General_Info">
                      {PageData?.PaymentInformationText}
                    </p>

                    {PageData.SepaAgreementText  &&
                      Model.PaymentMethod.type == 'sepadirectdebit' && (                        
                        <div className="Payment_General_Links_Info"
                        dangerouslySetInnerHTML={{
                          __html: PageData?.SepaAgreementText,
                        }}
                      />
                      )}
                    {(Model.IsInEditMode || PageData.IsPdfDownloadVisible) && (
                      <div className="Payment_General_Links_Info"
                        dangerouslySetInnerHTML={{
                          __html: PageData?.PdfDownloadText,
                        }}
                      />
                    )}
                  </div>
                </div>
              </section>

              <section className="CreateRepaymentPlan__section">
                <div id={Model.AdyenForm.FormRootNodeId}>
                  <PaymentContainer Model={Model} PageData={PageData} IsConfirmPaymentPlan={true} />
                  {Model.AdyenForm.IsPaymentError && (
                    <div className="adyen-payment-error">
                      {PageData?.AdyenPaymentError}
                    </div>
                  )}
                </div>

                <br style={{ clear: 'both' }} />
              </section>

              <section className="CreateRepaymentPlan__section">
                <div className="CreateRepaymentPlan__ctaWrapper CreateRepaymentPlan__ctaWrapper--centerAlign">
                  <PageLink
                    url={Model.ChoosePaymentMethodPageUrl}
                    text={PageData.ButtonBackLabel}
                    className="Button Button--gray CreateRepaymentPlan__cancelBtn Button_Width_Full"
                  />
                </div>
              </section>
            </main>
            </div>
          </div>
        </div>   
        </div>
    
  );
};
export default PaymentPlanConfirmPageData;
